import React from "react"
import NumberService from "../../services/NumberService";
import {useSelector} from "react-redux";
import {selectCurrencies, selectCurrency} from "../../store/currencySlice";


const WalletBalance = ({wallet}) => {
    const currency = useSelector(state => selectCurrency(state, wallet.currency));

    const value = wallet && wallet.value ? wallet.value :
        wallet && wallet.balance ? wallet.balance : 0;
    const sumToDisplay = value ? NumberService.formatSum(value) : "0";
    return <span>{sumToDisplay} {currency && currency.shortName}</span>
}

export default WalletBalance